import { Box, Flex, Text, useRadio, UseRadioProps } from '@chakra-ui/react';
import { RadioOption } from './RadioFilter';

interface LabelRadioProps {
    radioProps: UseRadioProps;
    data: RadioOption;
}

export const LabelRadio: React.FC<LabelRadioProps> = ({ data, radioProps }) => {
    const { getInputProps, getCheckboxProps, state } = useRadio(radioProps);
    const input = getInputProps();
    const checkbox = getCheckboxProps();

    return (
        <Box as="label">
            <input
                {...input}
                type="radio"
                className={'radio-input-element'}
                name={'radio-input'}
                style={{ overflow: 'hidden' }}
            />
            <Flex
                {...checkbox}
                className={
                    state.isChecked
                        ? `radio-label ${data.selectedClassName}`
                        : `radio-label ${data.className}`
                }
                cursor={'pointer'}
            >
                <Text>{data.option}</Text>
            </Flex>
        </Box>
    );
};
